import type { ComponentProps } from 'react';
import styled from '@emotion/styled';
const Container = styled.div<{
  containerWidth: number;
}>`
  --width: ${({
  containerWidth
}) => containerWidth}px;
  --padding: 2px;

  padding: var(--padding);
  width: var(--width);

  display: flex;

  transform: rotate(180deg);
`;
const ImageWrapper = styled.div<{
  imageCount: number;
  imageOffset: number;
}>`
  ${({
  imageCount,
  imageOffset
}) => `--diameter: calc((var(--width) - ${imageCount - 1} * ${imageOffset}px));`}

  flex-shrink: 0;

  width: var(--diameter);
  height: var(--diameter);
  border-radius: calc(var(--diameter) / 2);

  background-color: currentColor;
  border: 2px solid currentColor;

  overflow: hidden;

  ${({
  theme,
  imageOffset
}) => `margin-${theme.isRtl ? 'left' : 'right'}: calc(-1 * (var(--diameter) - ${imageOffset}px));`}

  ${({
  theme
}) => theme.isRtl ? 'transform: translateX(calc(var(--padding))) rotateZ(180deg);' : 'transform: translateX(calc(-1 * var(--padding))) rotateZ(180deg);'}
`;
const BlurredImage = styled.img`
  filter: blur(2px);

  width: 100%;
  height: 100%;

  object-fit: cover;
  object-position: center center;
`;
interface Props extends Pick<ComponentProps<'div'>, 'className'> {
  /** 사용할 이미지 URL들 */
  images: string[];
  /** 전체 이미지 리스트의 너비 (기본값: 50) */
  containerWidth?: number;
  /** 이미지가 삐져나오는 너비 (기본값: 10) */
  offset?: number;
}

/**
 * 사용자 프로필 사진을 중첩된 형태로 블러 처리하여 표시하는 컴포넌트
 *
 * @see {https://www.figma.com/design/HL9EukdsdexzTjvD5V98Y9/Guide---Follow-(%EA%B5%AC-Pin)?node-id=583-100839}
 *
 * @param {Props} props
 * @throws {Error} length가 2 미만일 경우
 * @throws {Error} containerWidth가 너무 작을 경우
 */
const BlurredUserPhotos = ({
  images,
  containerWidth = 50,
  offset = 10,
  ...props
}: Props) => {
  if (images.length <= 1) {
    throw new Error('length prop should be at least 2.');
  }
  if (containerWidth < images.length * offset) {
    throw new Error('offset mismatch');
  }
  const reversedImages = [...images].reverse();
  return <Container {...props} containerWidth={containerWidth} data-sentry-element="Container" data-sentry-component="BlurredUserPhotos" data-sentry-source-file="index.tsx">
      {reversedImages.map((imageSource, index) => <ImageWrapper key={index} imageCount={images.length} imageOffset={offset}>
          <BlurredImage src={imageSource} alt='' />
        </ImageWrapper>)}
    </Container>;
};
export default BlurredUserPhotos;